import React, { useState } from "react";
import Modal from "react-modal";
import { useForm } from "react-hook-form";
import {
  REVIEWS_SERVICE_ID,
  REVIEWS_TEMPLATE_ID,
  validation,
  validationEmail,
  validationName,
} from "../../common";
import { Cross, Done, Error } from "../../customIcons";
import { useEmailForm } from "../../hooks/useEmailForm";
import { Loader } from "../Loader";
import style from "./ReviewsModal.module.css";

Modal.setAppElement("#root");

export const ReviewsModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    reset,
  } = useForm({ mode: "onChange" });
  const { formRef, status, submit, resetStatus } = useEmailForm({
    serviceId: REVIEWS_SERVICE_ID,
    templateId: REVIEWS_TEMPLATE_ID,
    reset,
  });

  const isLoading = status === "loading";
  const isSubmitted = status === "success" || status === "error";

  const closeModal = () => {
    setIsOpen(false);
    resetStatus();
  };

  return (
    <div className={style.reviewsModalContainer}>
      <button
        type="button"
        className={style.reviewsModalButton}
        onClick={() => setIsOpen(true)}
      >
        <span className={style.reviewsModalButtonText}>Write a review</span>
      </button>
      <Modal
        overlayClassName={style.reviewsModalOverlay}
        className={style.reviewsModal}
        isOpen={isOpen}
        onRequestClose={closeModal}
        contentLabel="Write a review"
      >
        <button
          type="button"
          className={style.reviewsModalCrossButton}
          onClick={closeModal}
          aria-label="Close review form"
        >
          <Cross />
        </button>

        {isSubmitted ? (
          <div className={style.reviewsModalDoneContainer}>
            {status === "success" ? <Done /> : <Error />}
            <h2 className={style.reviewsModalDoneText}>
              {status === "success" ? "Done!" : "Error!"}
            </h2>
          </div>
        ) : (
          <>
            <h2 className={style.reviewsModalTitle}>Fill the form</h2>
            <form
              ref={formRef}
              className={style.form}
              onSubmit={handleSubmit(submit)}
              noValidate
            >
              <label className={style.formLabel} htmlFor="reviewsName">
                <span>First name*</span>
                <input
                  id="reviewsName"
                  autoComplete="name"
                  className={style.formInput}
                  {...register("reviewsName", validationName)}
                />
                {errors.reviewsName && (
                  <p className={style.formError}>
                    {errors.reviewsName.message}
                  </p>
                )}
              </label>
              <label className={style.formLabel} htmlFor="reviewsEmail">
                <span>Email*</span>
                <input
                  id="reviewsEmail"
                  type="email"
                  autoComplete="email"
                  className={style.formInput}
                  {...register("reviewsEmail", validationEmail)}
                />
                {errors.reviewsEmail && (
                  <p className={style.formError}>
                    {errors.reviewsEmail.message}
                  </p>
                )}
              </label>
              <label className={style.formLabel} htmlFor="reviewsMessage">
                <span>Message*</span>
                <textarea
                  id="reviewsMessage"
                  className={style.formMessage}
                  {...register("reviewsMessage", validation)}
                />
                {errors.reviewsMessage && (
                  <p className={style.formError}>
                    {errors.reviewsMessage.message}
                  </p>
                )}
              </label>
              <div className={style.submitButtonContainer}>
                <button
                  className={style.submitButton}
                  type="submit"
                  disabled={!isValid || isLoading}
                >
                  Submit
                </button>
              </div>
            </form>
          </>
        )}
      </Modal>
      {isLoading && <Loader />}
    </div>
  );
};
